export const SET_USER = 'SET_USER'

export const SET_DEVICES = 'SET_DEVICES'
export const ADD_DEVICES = 'ADD_DEVICES'
export const UPDATE_DEVICE = 'UPDATE_DEVICE'

export const SET_INFO_DEVICE_ID = 'SET_INFO_DEVICE_ID'

export const UPDATE_RELOAD_MAP = 'UPDATE_RELOAD_MAP'

export const SET_PROVIDER = 'SET_PROVIDER'
